import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import isMcSymbol from "utils/is-mc-symbol";
import { RandomFromArray } from "slotworks/utils/math/random";
import slotDefinition from "slotworks/model/slot-definition";
import { HoldAndSpinSymbolSchema } from "ags/integration/schema/ags-spin-response-schema";

export default function attachMCSymbols(mcSymbols: HoldAndSpinSymbolSchema[], record: SpinRecord) {

    if (!mcSymbols) {
        return;
    }

    // bonusSymbolSetup.drawAllBonusSymbols();

    mcSymbols.forEach((mcSymbol) => {

        if (!mcSymbol) {
            return;
        }

        const position = {
            x: mcSymbol.coordinate[0],
            y: mcSymbol.coordinate[1]
        };

        // TODO: if it's an mc symbol look up the value specific symbol.
        record.grid[position.x][position.y] = getSymbolNameFromId(mcSymbol.symbol);
    });
}

function getSymbolNameFromId(id: number): string {
    return slotDefinition.symbolDefinitions[id].id;
}

export function addValueToExistingMCSymbols(grid: string[][]) {

    const possibleValues = bonusSymbolSetup.getAnticipationSymbols();

    return grid.map((row) => {
        return row.map((symbol) => {
            if (isMcSymbol(symbol)) {
                const randomValue = RandomFromArray(possibleValues);
                return `TT_${randomValue}`;
            }

            return symbol;
        });
    });
}
